"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsBindingRequest = void 0;
var IsBindingRequest = /** @class */ (function () {
    function IsBindingRequest() {
    }
    return IsBindingRequest;
}());
exports.IsBindingRequest = IsBindingRequest;
;
//# sourceMappingURL=isBinding.request.js.map